import { fetchPitstopConfiguration } from "./fetchPitstopConfiguration";
import { retry } from "./retry";
import { staleWhileRevalidate } from "./staleWhileRevalidate";

const ONE_MINUTE_IN_SECONDS = 60;
const DEFAULT_FRESH_DURATION_IN_SECONDS = ONE_MINUTE_IN_SECONDS;
const DEFAULT_STALE_DURATION_IN_SECONDS = 5 * ONE_MINUTE_IN_SECONDS;

const CACHE_DURATION_IN_SECONDS = process.env.CACHE_DURATION_IN_SECONDS
  ? parseInt(process.env.CACHE_DURATION_IN_SECONDS, 10)
  : DEFAULT_FRESH_DURATION_IN_SECONDS;

const STALE_DURATION_IN_SECONDS = process.env.STALE_DURATION_IN_SECONDS
  ? parseInt(process.env.STALE_DURATION_IN_SECONDS, 10)
  : DEFAULT_STALE_DURATION_IN_SECONDS;

const NUMBER_OF_RETRY_ATTEMPTS = process.env.NUMBER_OF_RETRY_ATTEMPTS
  ? parseInt(process.env.NUMBER_OF_RETRY_ATTEMPTS, 10)
  : 5;
const RETRY_DELAY_IN_SECONDS = process.env.RETRY_DELAY_IN_SECONDS
  ? parseInt(process.env.RETRY_DELAY_IN_SECONDS, 10)
  : 5;

export const fetchPitstopConfigurationWithCache = staleWhileRevalidate(
  () =>
    retry(
      fetchPitstopConfiguration,
      NUMBER_OF_RETRY_ATTEMPTS,
      RETRY_DELAY_IN_SECONDS * 1000
    ),
  CACHE_DURATION_IN_SECONDS * 1000,
  STALE_DURATION_IN_SECONDS * 1000
);
